import { render } from "./WordDisplay.vue?vue&type=template&id=42370ba8&scoped=true"
import script from "./WordDisplay.vue?vue&type=script&lang=js"
export * from "./WordDisplay.vue?vue&type=script&lang=js"

import "./WordDisplay.vue?vue&type=style&index=0&id=42370ba8&scoped=true&lang=css"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\VueJs\\hangman\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42370ba8"]])

export default __exports__